import { React, useState } from 'react';
import TypingAnimation from './TypingAnimation';
import { navbarHeight } from '../App';
import { FaArrowDown } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';
import { Canvas } from '@react-three/fiber';
import Scene from './Scene';
import { useSpring } from '@react-spring/core';
import { OrbitControls } from '@react-three/drei';
import { a } from '@react-spring/web';
import { div as DivThree } from '@react-spring/web';
import { toggleTheme } from './DarkModeSwitch';


const HeroSection = ({ theme, setTheme, className, style }) => {

  const maxHeight = "1000px";
  const [{ background, fill }, set] = useSpring({ background: '#f0f0f0', fill: '#202020' }, [])

  return (
    <div id="home" className={`flex flex-col max-w-3xl h-screen p-8 m-auto justify-center text-dark dark:text-light ${className}`} style={{...style}}>
      <a.main className='absolute left-0 top-0 h-full w-screen z-10'>
        {/* Canvas occupies the entire hero section's background */}
        <Canvas>
          <Scene theme={theme} setTheme={setTheme}/>
        </Canvas>
      </a.main>
      <div className='flex items-center mx-auto px-5 md:mx-0 mt-20 mb-10 md:mb-20'>
        {/* Profile Picture */}
        <img 
          src="profile_pic.JPG"
          className='object-center aspect-square rounded-full max-h-72 shadow-4xl z-10 md:z-0'
        />
      </div>
      <div className='flex flex-col text-left sm:mx-5 md:mx-0'>
        <div className=' text-5xl sm:text-5xl md:text-7xl'>
          Hi, I'm <span className='font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-theme-orange to-theme-turquoise'>Philipp</span>.
        </div>
        <div className='flex flex-nowrap mt-5 h-20 text-4xl sm:text-5xl md:text-6xl'>
          I&nbsp;&nbsp;<TypingAnimation textArray={['study robotics.', 'code :).', 'build AI.', 'design Apps.', 'write an ML blog.', 'like challenges.']} waitTime={40} className={`font-mono tracking-tighter ${className}`}/>
        </div>
      </div>
      <div className='z-10 mb-14 mt-10 md:mt-18 flex w-full mx-auto justify-center animate-pulse text-4xl'>
        <ScrollLink to="about" smooth={true} duration={500} spy={true} exact="true" offset={-56}>
          <FaArrowDown className='h-14 px-1 border-4 border-dark dark:border-light rounded-3xl cursor-pointer'/>
        </ScrollLink>
      </div>
    </div>
  )
}

export default HeroSection